
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"200","height":"200","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"x":"-10.5%","y":"-7.2%","width":"121%","height":"119.3%","filterUnits":"objectBoundingBox","id":"id-95a"}},[_c('feMorphology',{attrs:{"radius":"1","operator":"dilate","in":"SourceAlpha","result":"shadowSpreadOuter1"}}),_c('feOffset',{attrs:{"dy":"4","in":"shadowSpreadOuter1","result":"shadowOffsetOuter1"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"4","in":"shadowOffsetOuter1","result":"shadowBlurOuter1"}}),_c('feComposite',{attrs:{"in":"shadowBlurOuter1","in2":"SourceAlpha","operator":"out","result":"shadowBlurOuter1"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0.388235294 0 0 0 0 0.517647059 0 0 0 0.1 0","in":"shadowBlurOuter1"}})]),_c('path',{attrs:{"d":"M99.644 22l79.513 72.36h-18.77V179h-121V94.36h-18.23L99.644 22z","id":"id-96b"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('use',{attrs:{"fill":"#000","filter":"url(#id-95a)","xlink:href":"#id-96b"}}),_c('path',{attrs:{"stroke-opacity":".04","stroke":"#006384","d":"M99.642 21.322l80.807 73.539-19.562-.001v84.64h-122V94.86h-19.01l79.765-73.538z","fill":"#FFF"}})])])
          )
        }
      }
    